import { OrderProof } from "@app/types/orders";
import { Proof } from "@app/domain";

export function toProof(proof: OrderProof): Proof {
  switch (proof.type) {
    case "signature":
      return { id: proof.id, kind: "signature", signatureUrl: proof.signatureUrl, capturedAt: proof.createdAt };
    case "photo":
      return { id: proof.id, kind: "photo", photoUrl: proof.photoUrl, capturedAt: proof.createdAt };
    case "barcode-scan":
      return {
        id: proof.id,
        kind: "barcode",
        code: proof.barcodeData,
        label: proof.barcodeDataKey ? proof.barcodeDataKey.charAt(0).toUpperCase() + proof.barcodeDataKey.slice(1) : undefined,
        capturedAt: proof.createdAt,
      };
  }
}
